import { LDFlagSet } from 'launchdarkly-js-sdk-common';

import { pilot } from '~/services/serviceInstances';

export const getClientFeatureFlags = async ({
  clientId,
}: {
  clientId: number;
}): Promise<LDFlagSet> => {
  const response = await pilot.get(`client/${clientId}/flags`);
  return response;
};
